<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom landing-page"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <hero-block
      v-bind="heroBlock"
      edit-prefix="HeroBlock"
    />
    <div
      v-if="contentBlocks.length || (isEditable && contentBlocks.length)"
      v-edit="'ContentBlocks'"
      class="usp-block-wrapper"
    >
      <in-view
        v-for="(block, index) in contentBlocks"
        :key="'contentBlocks--' + block.contentId"
        :threshold="threshold"
        :threshold-type="'px'"
      >
        <component
          :is="block.component | kebab"
          v-bind="block"
          :class=" {'first': index === 0, 'last': index === contentBlocks.length -1}"
        />
      </in-view>
    </div>

    <div
      v-if="accordionBlocks.length || (isEditable && accordionBlocks.length)"
      class="accordion-block-wrapper"
    >
      <sub-heading
        v-if="accordionsHeading || isEditable"
        :v-edit-heading="'AccordionsHeading'"
        :heading="accordionsHeading"
      />

      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          v-edit="'AccordionBlocks'"
        >
          <accordion-group
            :items="accordionBlocks | stringify('content')"
            :limit="isEditable ? 0 : accordionShowMoreLimit"
            :tracking-scope="accordionsHeading"
          />
        </div>
      </in-view>
    </div>

    <navigation-blocks
      v-if="allNavigatablePages.length"
      :navigation-blocks="allNavigatablePages"
      :display-image-state="displayImagesInNavigationBlocks"
    >
      <sub-heading
        v-if="navigationHeading || isEditable"
        :v-edit-heading="'NavigationHeading'"
        :heading="navigationHeading"
      />
    </navigation-blocks>


    <additional-navigation-blocks
      v-if="isEditable"
      :items="additionalNavigatablePages"
    />
  </div>
</template>
<script>
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import pageBlockTypes from '@/vue/mixins/pageBlockTypes'

export default {
  name: "LandingPage",
  mixins: [pageWithNavigation,pageBlockTypes],
  props: {
    accordionShowMoreLimit: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss">
  .landing-page {
    @import "@/style/_epiBackground.scss";
    @import "@/style/_uspblock.scss";
  }
</style>
